import React, { useEffect, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const DivisibilityDash = () => {
  const [currentNumber, setCurrentNumber] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [step, setStep] = useState('');
  const correctSoundRef = React.useRef(null);
  const wrongSoundRef = React.useRef(null);

  const generateNumber = () => {
    const num = Math.floor(Math.random() * 899) + 100;
    setCurrentNumber(num);
    setStep(`Sum of digits: ${sumDigits(num)}`);
    setFeedback('');
  };

  const sumDigits = (n) => {
    return n
      .toString()
      .split('')
      .reduce((sum, digit) => sum + parseInt(digit), 0);
  };

  const isDivisibleBy3 = (n) => sumDigits(n) % 3 === 0;

  const checkAnswer = (answer) => {
    const correct = isDivisibleBy3(currentNumber);
    if (answer === correct) {
      setFeedback(
        `🌟 Great! It's ${correct ? 'divisible!' : 'not divisible!'}`
      );
      if (correctSoundRef.current) correctSoundRef.current.play();
            const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    } else {
      setFeedback('❌ Oops! Try again.');
      if (wrongSoundRef.current) wrongSoundRef.current.play();
    }

    setTimeout(generateNumber, 1500);
  };

  useEffect(() => {
    generateNumber();
  }, []);

  const styles = {
    body: {
      fontFamily: 'Comic Sans MS, cursive',
      background: 'radial-gradient(circle, #0d0d2b, #1d1d40)',
      color: 'white',
      textAlign: 'center',
      padding: '40px',
      minHeight: '100vh',
    },
    h1: {
      fontSize: '2.5rem',
      marginBottom: '20px',
      color: '#03dac6',
    },
    spaceship: {
      width: '80px',
      animation: 'float 2s ease-in-out infinite',
      marginTop: '10px',
    },
    number: {
      fontSize: '5rem',
      margin: '20px 0',
      color: '#ffab00',
    },
    step: {
      fontSize: '1.5rem',
      marginBottom: '20px',
    },
    button: {
      fontSize: '1.8rem',
      padding: '15px 30px',
      margin: '10px',
      border: 'none',
      borderRadius: '12px',
      cursor: 'pointer',
      transition: '0.2s ease',
    },
    yes: {
      backgroundColor: '#4caf50',
      color: 'white',
    },
    no: {
      backgroundColor: '#f44336',
      color: 'white',
    },
    feedback: {
      fontSize: '2rem',
      height: '40px',
      marginTop: '10px',
    },
    '@keyframes float': {
      '0%': { transform: 'translateY(0)' },
      '50%': { transform: 'translateY(-10px)' },
      '100%': { transform: 'translateY(0)' },
    },
  };

  return (
    <div style={styles.body}>
      <h2 style={styles.h1}>🚀 Divisibility Dash</h2>
      <p  style={{ color:"red" }}  >Is the number divisible by 3? 🤔</p>
      
      <div style={styles.number}>{currentNumber}</div>
      <div style={styles.step}>{step}</div>

      <button
        style={{ ...styles.button, ...styles.yes }}
        onClick={() => checkAnswer(true)}
      >
        ✅ YES
      </button>
      <button
        style={{ ...styles.button, ...styles.no }}
        onClick={() => checkAnswer(false)}
      >
        ❌ NO
      </button>

      <div style={styles.feedback}>{feedback}</div>

      <audio
        ref={correctSoundRef}
        src="https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg"
      ></audio>
      <audio
        ref={wrongSoundRef}
        src="https://actions.google.com/sounds/v1/cartoon/cartoon_boing.ogg"
      ></audio>
    </div>
  );
};

export default DivisibilityDash;
